export const ALPHABETIC_REGEX = /^$|^[A-Za-z ]+$/;
export const NUMERIC_REGEX = /^$|^\d+$/;
export const ALPHANUMERIC_REGEX = /^$|^[A-Za-z0-9 ]+$/;
export const EMAIL_REGEX = 
// eslint-disable-next-line no-control-regex, no-useless-escape
/^([a-zA-Z0-9_.-]{1,})@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,4}$/; // NOSONAR
export const AUTHENTICATION_NO_REGEX = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]+$/;
export const AUTHENTICATION_UEN_NO_REGEX = /^[^%&]{1,20}$/;
export const UEN_FORMAT_A_REGEX = /^\d{9}[A-Za-z]$/;
export const UEN_FORMAT_B_REGEX = /^[1-2]\d{3}\d{5}[A-Za-z]$/;
export const UEN_FORMAT_C_REGEX = /^[TtSsRr]\d{2}[A-Za-z][A-Za-z0-9]\d{4}[A-Za-z]$/;
